module.exports = __webpack_public_path__ + "img/blog-11.6ce4ac91.jpg";